import angular from 'angular';

angular.module('cloudX').directive('cxFiscalCostList', function () {
  return {
    restrict: 'E',
    template: require('./fiscalCostList.html'),
    bindToController: { field: '=', relId: '@', list: '=value' },
    controllerAs: 'vm',
    require: ['^cxRelationFile', 'cxFiscalCostList'],
    link: function (scope, el, attrs, controllers) {
      if (!controllers || controllers.length !== 2) return;
      var cxRelFile = controllers[0];
      var controller = controllers[1];
      controller.setRelationFile(cxRelFile);
    },
    controller: [
      '$http',
      'appUrls',
      'flySvc',
      'dialogsSvc',
      'checkSecurity',
      '$timeout',
      function ($http, appUrls, flySvc, dialogsSvc, checkSecurity, $timeout) {
        const vm = this;
        var relationFile = null;

        vm.$onInit = function () {
          if (!vm.list) vm.list = [];
          vm.documents = {};
          vm.documentLinkType = 7;
          vm.showCostModal = false;
          vm.activeCost = null;
          vm.activeDocuments = [];

          if (vm.list && vm.list.length && checkSecurity('Documents:r')) {
            $http
              .post(
                `${appUrls.documents}/api/documents/GetLinks/${vm.documentLinkType}`,
                vm.list.map((x) => x.id),
              )
              .then(function (response) {
                var result = response.data;
                angular.extend(vm.documents, result);
              })
              .catch(function (error) {
                flySvc.error(error);
                return '';
              });
          }
        };

        vm.setRelationFile = function (relFile) {
          relationFile = relFile;
        };

        vm.showDialog = function (item = null) {
          vm.activeCost = item ? angular.copy(item) : null;
          vm.activeDocuments = item ? vm.documents[item.id] || [] : [];
          vm.showCostModal = true;
          vm._editingItem = item;
        };

        vm.onCostModalSave = function (result, documents) {
          $timeout(function () {
            if (result) {
              if (vm._editingItem && vm._editingItem.id) {
                angular.extend(vm._editingItem, result);
              } else {
                vm.list.push(result);
              }
              if (relationFile) {
                relationFile.refreshOpenSections();
              }
            }
            const itemId =
              (vm._editingItem ? vm._editingItem.id : null) || (result ? result.id : null);
            if (documents && itemId) {
              vm.documents[itemId] = [...documents];
            }
            vm.showCostModal = false;
            vm.activeCost = null;
            vm.activeDocuments = [];
            vm._editingItem = null;
          }, 0);
        };

        vm.onCostModalClose = function (documents) {
          $timeout(function () {
            if (documents && vm._editingItem && vm._editingItem.id) {
              vm.documents[vm._editingItem.id] = [...documents];
            }
            vm.showCostModal = false;
            vm.activeCost = null;
            vm.activeDocuments = [];
            vm._editingItem = null;
          }, 0);
        };

        vm.onCreateRelation = function (onCreated) {
          dialogsSvc
            .showRelationWizard('newRelation', { relType: 2, crmType: 0 })
            .then(function (result) {
              if (result && result.relation && result.relation.id) {
                $timeout(function () {
                  if (onCreated) {
                    onCreated(result.relation);
                  }
                }, 0);
              }
            });
        };

        vm.add = () => vm.showDialog(null);
        vm.edit = (item) => vm.showDialog(item);

        vm.remove = function (item) {
          if (item.deleting) return;
          return dialogsSvc.showYesNo('comfirmDeleteTitle', 'comfirmDeleteItem').then(
            function () {
              item.deleting = true;
              return $http.delete(`${appUrls.api}/api/Fiscal/Cost/${item.id}`).then(
                () => {
                  item.deleting = false;
                  const idx = vm.list.indexOf(item);
                  if (idx >= 0) {
                    vm.list.splice(idx, 1);
                  }
                  if (vm.documents[item.id] && vm.documents[item.id].length > 0) {
                    return $http
                      .delete(
                        `${appUrls.documents}/api/documents/Links/${item.id}/${vm.documentLinkType}`,
                      )
                      .then(() => {
                        delete vm.documents[item.id];
                        flySvc.success('msgItemRemoved');
                      });
                  }
                  flySvc.success('msgItemRemoved');
                },
                (error) => {
                  item.deleting = false;
                  flySvc.error(error);
                },
              );
            },
            function () {
              return false;
            },
          );
        };
        vm.uploadDocuments = function (files, item) {
          if (!item || !item.id) return;
          if (!files || files.length < 1) return;
          var formData = new FormData();
          formData.append('relationId', vm.relId);
          formData.append('documentLinkType', vm.documentLinkType);
          formData.append('linkId', item.id);

          files.forEach(function (file) {
            formData.append('data', file.data);
          });

          $http({
            method: 'POST',
            url: appUrls.documents + '/api/documents?documentType=-1',
            headers: {
              'Content-Type': undefined,
            },
            data: formData,
          })
            .then(function (response) {
              var result = response.data;
              if (result && result.length > 0) {
                if (!vm.documents[item.id]) vm.documents[item.id] = [];

                result.forEach(function (file) {
                  vm.documents[item.id].push(file);
                });
                flySvc.success();
              }
            })
            .catch(function (error) {
              flySvc.error(error);
              return '';
            });
        };
      },
    ],
  };
});
